import createEnum from 'lib/createEnum';

export const TYPES = { TEXT: 'text', IMAGE: 'image', FILE: 'file' };
export const SUB_TYPES = createEnum('CREDIT_CARD_REQUEST', 'FILE', 'IMAGE', 'SESSION_END', 'TEXT', 'URL');

export const SECURE_DATA_REQUEST_STATUSES = createEnum(
  'ABANDONED',
  'AWAITING_INPUT',
  'COMPLETED',
  'DECLINED',
  'ERROR',
  'REQUESTING',
  'SUBMITTED',
  'TIMED_OUT'
);

export default {
  SECURE_DATA_REQUEST_STATUSES,
  SUB_TYPES,
  TYPES,
};
